import React from 'react'
import SuggestItem from './SuggestItem'
import s from './SuggestContentList.less'

const SuggestContentList = ({
  suggestions = [],
  idxStartAt = 0,
  onClick,
  selectedId = -1,
  updateSelectedId = () => {}
}) => (
  <div className={s.SuggestList}>
    <ul>
      {suggestions.map((suggest, index) => {
        const idx = idxStartAt + index
        return (
          <li key={idx} className={selectedId === idx ? s.selected : ''}>
            <SuggestItem {...{ idx, suggest, onClick, updateSelectedId }} />
          </li>
        )
      })}
    </ul>
  </div>
)

export default SuggestContentList
